import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { QueryClientProvider } from '@tanstack/react-query';
import { routes } from './routes/routes';
import { AuthProvider } from './contexts/AuthContext';
import { theme } from './theme/theme';
import SnackbarWrapper from './contexts/SnackbarContext';
import { AuthEventListener } from './contexts/AuthEventListener';
import { queryClient } from './lib/queryClient';

const router = createBrowserRouter(routes);

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <SnackbarWrapper>
          <AuthProvider>
            <AuthEventListener />
            <RouterProvider router={router} />
          </AuthProvider>
        </SnackbarWrapper>
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;
